import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ModalAccessData {
  modalTitle: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  tertiaryButtonText?: string;
}

@Component({
  selector: 'app-modal-access',
  templateUrl: './modal-access.component.html',
  styleUrls: ['./modal-access.component.scss'],
  standalone: false,
})
export class ModalAccessComponent {
  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalAccessData,
    public dialogRef: MatDialogRef<ModalAccessComponent>,
  ) {}

  public cancelButtonClicked(): void {
    this.dialogRef.close('tertiary');
  }

  public confirmButtonClicked(): void {
    this.dialogRef.close('primary');
  }

  public secondaryButtonClicked(): void {
    this.dialogRef.close('secondary');
  }

  public closeDetail(): void {
    this.dialogRef.close('close');
  }
}
